/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function addThumbnailScrollArrows() {
  document.querySelectorAll('.product-gallery__thumbnail-list').forEach(list => {
    if (list.dataset.scrollArrows) return;
    list.dataset.scrollArrows = 'true';

    function makeArrow(direction) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'thumbnail-scroll-arrow';
      button.setAttribute('aria-label', `Scroll thumbnails ${direction}`);

      const path = direction === 'up'
        ? 'M5 15l7-7 7 7'
        : 'M5 9l7 7 7-7';

      button.innerHTML = `
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="${path}" fill="none" stroke="currentColor"
            stroke-width="2.5" stroke-linecap="round"
            stroke-linejoin="round"/>
        </svg>`;

      button.addEventListener('click', () => {
        list.scrollBy({
          top: direction === 'up' ? -160 : 160,
          behavior: 'smooth'
        });
      });

      return button;
    }

    const up = makeArrow('up');
    const down = makeArrow('down');

    list.before(up);
    list.after(down);

    function updateArrows() {
      up.disabled = list.scrollTop <= 1;
      down.disabled =
        list.scrollTop + list.clientHeight >= list.scrollHeight - 1;
    }

    list.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    window.addEventListener('load', updateArrows);

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateArrows).observe(list);
    }

    updateArrows();
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', addThumbnailScrollArrows);
} else {
  addThumbnailScrollArrows();
}

document.addEventListener('shopify:section:load', addThumbnailScrollArrows);
